import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpClient } from "@/shared/api/http-client";
import type { UserSummary } from "./types";
import { USERS_LIST_QUERY_KEY, USER_DETAIL_QUERY_KEY } from "./constants";

/**
 * Manually marks a user's phone as verified via
 * `POST /api/admin/users/:id/phone/verify`. Used when a user can't or
 * won't complete the in-app OTP loop and an operator (admin or support)
 * confirms the number out of band. Returns the updated `UserSummary`
 * (which carries no phone fields); the hook refetches the detail.
 */
async function verifyPhone(id: string): Promise<UserSummary> {
  return httpClient<UserSummary>(`/api/admin/users/${encodeURIComponent(id)}/phone/verify`, {
    method: "POST",
  });
}

export function useVerifyPhone() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: verifyPhone,
    onSuccess: (_data, id) => {
      queryClient.invalidateQueries({ queryKey: USERS_LIST_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: [...USER_DETAIL_QUERY_KEY, id] });
    },
  });
}
